import { NgModule } from "@angular/core";
import { CoreModule } from "../../core/core.module";
import { SharedModule } from "../../shared/shared.module";
import { ConfirmAccountComponent } from "./confirm-account/confirm-account.component";
import { ForgotPasswordComponent } from "./forgot-password/forgot-password.component";
import { IndexHeaderComponent } from "./index-header/index-header.component";
import { IndexRoutingModule } from "./index-routing.module";
import { IndexComponent } from "./index.component";
import { LoginComponent } from "./login/login.component";
import { LogoutComponent } from "./logout/logout.component";
import { MultifactorAuthComponent } from "./multifactor-auth/multifactor-auth.component";
import { RegisterComponent } from "./register/register.component";
import { ResetComponent } from "./reset/reset.component";
import { IndexLayoutComponent } from "./index-layout/index-layout.component";

@NgModule({
  declarations: [
    ConfirmAccountComponent,
    ForgotPasswordComponent,
    IndexHeaderComponent,
    LoginComponent,
    LogoutComponent,
    RegisterComponent,
    ResetComponent,
    IndexComponent,
    MultifactorAuthComponent,
    IndexLayoutComponent,
  ],
  imports: [IndexRoutingModule, CoreModule, SharedModule],
  exports: [
    ConfirmAccountComponent,
    ForgotPasswordComponent,
    IndexHeaderComponent,
    LoginComponent,
    LogoutComponent,
    RegisterComponent,
    ResetComponent,
    IndexComponent,
    MultifactorAuthComponent,
  ],
})
export class IndexModule {}
